export var ProgramSupportEnum = [
    {
        label: "RES+ Nové obnovitelné zdroje v energetice",
        value: "RES",
    },
    {
        label: "HEAT Modernizace soustav zásobování tepelnou energií",
        value: "HEAT",
    },
    {
        label: "ENERG ETS Zlepšení energetické účinnosti a snižování emisí skleníkových plynů v průmyslu v EU ETS",
        value: "ENERG",
    },
    {
        label: "ENERGov Energetické úspory ve veřejných budovách",
        value: "ENERG2",
    },
    {
        label: "TRANSPORT Modernizace dopravy",
        value: "TRANSPORT",
    },
    {
        label: "GREENGAS Obnovitelná plynná a kapalná paliva",
        value: "GREENGAS",
    },
    {
        label: "SMARTNET Modernizace energetických soustav",
        value: "SMARTNET",
    },
    {
        label: "KOMUNERG Komunitní energetika",
        value: "KOMUNERG",
    },
    {
        label: "I+ Inovativní a komplexní projekty",
        value: "I",
    },
];
